import React from "react";
import Header from "../../../Header/Header";
import Footer from "../../../Footer/Footer";
import InnerTestimonial from "./InnerTestimonial";

const Testimonials = () => {
  return (
    <>
      <Header />
      <InnerTestimonial />
      <Footer />
    </>
  );
};

export default Testimonials;
